import { GET_VEHICLE_SUCCESS, GET_VEHICLE_FAILURE } from "../constants/MyM";
import { getApi } from "../../utils/apiCall";

const vehicleSuccess = (data) => {
  return {
    type: GET_VEHICLE_SUCCESS,
    payload: data,
  };
};

const vehicleFailure = (data) => {
  return {
    type: GET_VEHICLE_FAILURE,
    payload: data,
  };
};

export const getVehicleData = (ids) => {
  return async (dispatch, getState) => {
    const { error, result } = await getApi(`/vehicle_details`);
    if (!error) {
      return dispatch(vehicleSuccess(result));
    }
    return dispatch(vehicleFailure(result));
  };
};
